import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import clsx from 'clsx';
import classes from './styles.module.css';
export const HBox = forwardRef(({ children, className, ...props }, ref) => {
    return (_jsx("div", { className: clsx(classes.hbox, className), ...props, ref: ref, children: children }));
});
export const VBox = forwardRef(({ children, className, ...props }, ref) => {
    return (_jsx("div", { className: clsx(classes.vbox, className), ...props, ref: ref, children: children }));
});
export const Pane = forwardRef(({ children, stretch, paddingX, scrollable, className, style = {}, ...props }, ref) => {
    const paddingXValue = typeof paddingX === 'boolean' ? 100 : paddingX;
    const passedStyle = paddingXValue
        ? {
            '--pane-padding-x': `var(--pane-padding-x-${paddingXValue})`,
            ...style,
        }
        : style;
    return (_jsx("div", { ref: ref, style: passedStyle, className: clsx(classes.pane, stretch && classes.pane__stretch, scrollable && classes.pane__scrollable, className), ...props, children: children }));
});
//# sourceMappingURL=index.js.map